
const toolOptions = [
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote', 'code-block'],
    [{'header': 1}, {'header': 2}],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],
    [{'indent': '-1'}, {'indent': '+1'}],
    [{'direction': 'rtl'}],
    [{'size': ['small', false, 'large', 'huge']}],
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],
    [{'font': []}],
    [{'align': []}],
    ['clean'],
    ['link', 'image', 'video'],
    ['sourceEditor']     //新添加的工具
  ];
  const handlers = {
    shadeBox:null,
    sourceEditor: function(){
          let inputButton = document.getElementsByClassName('file-input')[0]
          inputButton.click()
    }
  };
   
  export default {
    placeholder: '这里输入文字...',
    theme: 'snow',  // 主题
    modules: {
      toolbar: {
        container: toolOptions,  // 工具栏选项
        handlers: handlers  // 事件重写
      }
    },
    initButton:function(){      //在使用的页面中初始化按钮样式
      const sourceEditorButton = document.querySelector('.ql-sourceEditor');
      sourceEditorButton.style.cssText = "width:80px;font-size:14px;font-weight:500";
      sourceEditorButton.innerText="上传附件";
      sourceEditorButton.classList.add('el-icon-upload2');
      
      
    }
}